/* eslint react/no-multi-comp: 0, react/prop-types: 0 */

import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { connect } from 'react-redux'

class DeleteTemplateModal extends React.Component {
  render() {

    const { localisation } = this.props.userReducer;

    return (
      <div>
        <Modal isOpen={this.props.visible} toggle={this.props.toggle} className={this.props.className}>
          <ModalHeader toggle={this.props.toggle}>{localisation['delete_template_header'] ? localisation['delete_template_header'].element_lang : ''}</ModalHeader>
          <ModalBody>
            {localisation['delete_template_confirmation_text'] ? localisation['delete_template_confirmation_text'].element_lang + ' '
              + this.props.name
              + ' '
              + this.props.language
              + ' '
              + this.props.folder
              + '?'
              : ''
              + this.props.name
              + ' '
              + this.props.language
              + ' '
              + this.props.folder}
          </ModalBody>
          <ModalFooter>
            <Button color="danger" onClick={() => this.props.removeTemplate(this.props.file._id)}>Delete</Button>{' '}
            <Button color="secondary" onClick={this.props.toggle}>Cancel</Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

export default connect(state => state)(DeleteTemplateModal);